module.exports = __webpack_public_path__ + "img/appIcon-menu--Contacts.5ca5b303.svg";